import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";  // ✅ Import Link

import "../components/CourierInformation.css";

const CourierInformation = () => {
  const [couriers, setCouriers] = useState([
    { id: 1, name: "John Doe", status: "Delivered", location: "Delhi", trackingUrl: "https://trackcourier.com/track/john" },
    { id: 2, name: "Jane Smith", status: "In Transit", location: "Mumbai", trackingUrl: "https://trackcourier.com/track/jane" },
    { id: 3, name: "Amit Sharma", status: "Pending", location: "Chennai", trackingUrl: "https://trackcourier.com/track/amit" },
    { id: 4, name: "Priya Verma", status: "Dispatched", location: "Bangalore", trackingUrl: "https://trackcourier.com/track/priya" },
  ]);

  const [showForm, setShowForm] = useState(false);
  const [newCourier, setNewCourier] = useState({
    name: "",
    status: "Pending",
    location: "",
    trackingUrl: ""
  });

  // Toggle form visibility
  const handleAddClick = () => {
    setShowForm(true);
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewCourier({ ...newCourier, [name]: value });
  };

  // Submit new courier
  const handleSubmit = (e) => {
    e.preventDefault();
    const courierToAdd = { ...newCourier, id: couriers.length + 1 };
    setCouriers([...couriers, courierToAdd]);
    setNewCourier({ name: "", status: "Pending", location: "", trackingUrl: "" });
    setShowForm(false);
  };

  // Delete courier
  const handleDelete = (id) => {
    const updatedCouriers = couriers.filter(courier => courier.id !== id);
    setCouriers(updatedCouriers);
  };

  return (
    <div className="courier-container">
      {/* Heading with Add Courier Button */}

      <div className="heading-bar">
        <h2 className="page-title">🚚 Manage Your Couriers       
          <button className="add-btn" onClick={handleAddClick}>➕ </button>
        </h2>
        {/* <h1 className="header-title">User Management</h1> */}
        <nav className="header-nav">
          <a href="DashBoard">Home</a>
          <span>/</span>
          <span>CourierInformation</span>
        </nav>


      </div>


      {/* Form for adding courier */}
      {showForm && (
        <form className="courier-form" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Courier Name"
            value={newCourier.name}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="status"
            placeholder="Status"
            value={newCourier.status}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="location"
            placeholder="Location"
            value={newCourier.location}
            onChange={handleChange}
            required
          />
          <input
            type="url"
            name="trackingUrl"
            placeholder="Tracking URL"
            value={newCourier.trackingUrl}
            onChange={handleChange}
            required
          />
          <button type="submit">Add Courier</button>
        </form>
      )}

      {/* Courier Cards */}
      <motion.div
        className="courier-grid"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        {couriers.map((courier, index) => (
          <motion.div
            key={courier.id}
            className={`courier-card status-${courier.status.toLowerCase().replace(" ", "-")}`}
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: index * 0.2 }}
            whileHover={{ scale: 1.05 }}
          >
            <h3>{courier.name}</h3>
            <p><strong>Status:</strong> {courier.status}</p>
            <p><strong>Location:</strong> {courier.location}</p>

            {/* Buttons */}
            <div style={{ display: "flex", gap: "0.5rem", marginTop: "1rem" }}>
              <button
                className="track-btn"
                onClick={() => window.open(courier.trackingUrl, "_blank")}
              >
                🔗 Track
              </button>
              <button
                className="delete-btn"
                onClick={() => handleDelete(courier.id)}
              >
                🗑️ Delete
              </button>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default CourierInformation;
